import React, { useState, useEffect } from 'react';
import Highcharts from 'highcharts';
import { useRecoilValueLoadable } from 'recoil';
import { metrics } from '../../../recoil/selectors/metrics';
import { hhmmss, HighchartsReactWithStyles } from './HighchartsReactWithStyles';
export function AgentSummaryBarChart() {
  const [loading, setLoading] = useState(true);
  const [chartOptions, setChartOptions] = useState({});
  const metric = useRecoilValueLoadable(metrics);

  useEffect(() => {
    setLoading(true);
    if (metric?.state === 'hasValue') {
      if (metric?.contents?.options) {
        if (
          metric?.contents?.options?.yAxis?.title?.text?.toLowerCase() ===
            'total duration' ||
          metric?.contents?.options?.yAxis?.title?.text?.toLowerCase() ===
            'avg. duration'
        ) {
          setChartOptions({
            ...metric?.contents?.options,
            yAxis: {
              ...metric?.contents?.options?.yAxis,
              labels: {
                formatter: function () {
                  return hhmmss(Number(this.value));
                },
              },
            },
          });
          setLoading(false);
        } else {
          setChartOptions({ ...metric?.contents?.options });
          setLoading(false);
        }
      }
    }
  }, [metric]);

  return (
    <div>
      <HighchartsReactWithStyles
        allowChartUpdate={true}
        highcharts={Highcharts}
        options={chartOptions}
        loading={metric.state === 'loading' || loading}
      />
    </div>
  );
}
